<nav class="top-bar search-{{isMobileSearchView }} d-flex align-items-center flex-row flex-nowrap px-3" [ngClass]="{'justify-end': searchboxClicked}">
    <div id="topmenuhide1" [ngClass]="{'hide-topmenu': searchboxClicked}">
        <div class='d-flex flex-row w-100 align-items-center justify-content-center '>

            <img class="medium-logo" src='assets/qwyn/icons/white-logo.svg' alt="Show">


            <span class='nav-items' (click)="selectedMenu !== 'dashboard' && selectedMenu !== 'DASHBOARD' && selectMenuItem('dashboard',0)"
                [ngClass]="{'active': selectedMenu === 'dashboard' ||  selectedMenu === 'DASHBOARD'}">Dashboard</span>

            <div class="nav-items messages" (mouseenter)="isMegaMenuOpen = true" (mouseleave.prevent)="isMegaMenuOpen = false"
                (click)="selectedMenu !== 'messages' && selectMenuItem('messages',1);" [ngClass]="{'active': selectedMenu === 'messages'}">
                Messages
                <i class="message_icon fa fa-chevron-down"
                    [ngClass]="{'rotate-up': isMegaMenuOpen}">
                </i>
                <div class="mega-menu"  (click)="$event.stopPropagation()" onkeypress="$event.stopPropagation()">
                  <div class="mega-menu-content">
                    <app-megamenu></app-megamenu>
                  </div>
                </div>
            </div>
            <div class="nav-items messages" (mouseenter)="isReportsMegaMenuOpen = true" (mouseleave)="isReportsMegaMenuOpen = false"
                 [ngClass]="{'active': selectedMenu === 'reports' || selectedMenu === 'REPORTS' || selectedMenu === 'REPORT CRITERIA' || isValidReportType(selectedMenu)}">
                Reports
                <i class="message_icon fa fa-chevron-down" [ngClass]="{'rotate-up': isReportsMegaMenuOpen}">
                </i>
                <div class="mega-menu" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
                    style="height: 94px; width: 230px;">
                    <div class="mega-menu-content" style="padding: 8px !important;height:100px">
                        <app-megamenureport></app-megamenureport>
                    </div>
                </div>
            </div>
            <p class='nav-items' *ngIf="hasGroupRole" (click)="selectedMenu !== 'groupAdmin' && selectedMenu !== 'GROUPADMIN' && selectMenuItem('groupAdmin',3)"
                [ngClass]="{'active': selectedMenu === 'groupAdmin' ||  selectedMenu === 'GROUPADMIN'}">
                Group Admin</p>
        </div>
    </div>
    <div class='d-flex flex-row align-items-center justify-content-center ' id='right-side-options'>

        <!-- Searchbox with dropdown section starts -->
        <div *ngIf='searchboxClicked' class="search" [ngClass]="{'search-focused':inputFocused}">
            <div appOuterClick (outsideClick)="onInputClick(false);clearItem(autocomplete)" class="navbar-left">
                <form class="form-horizontal" [formGroup]="searchForm" (keydown.enter)="$event.preventDefault()">
                    <div *ngIf="isMobile && !inputFocused" class="sidebaricon">
                        <div class="topnav-icons w3-left w3-bar-item w3-button" id="mobileMenuClick"
                            (click)="showSlide($event)">
                            <img src="assets/mobile/hamburger.svg" alt="">
                        </div>
                    </div>
                    <div *ngIf="isMobile && inputFocused" (click)="enableBackButton()">
                        <img class="backward-icon" src="assets/Inbox/right_chevron_icon.svg" alt="">
                    </div>
                    <div class="mobile_header_text flex-row align-items-center justify-content-start">
                        <div class="mobile-label">{{currentTab.header}}</div>
                        <div *ngIf="currentTab.count" class="custom-badge">{{displayEllipsis(currentTab.count)}}</div>
                    </div>
                    <div class="input-group">
                        <div class="input-group-prepend searchBoxLeft" style="display:none">
                            <button [hidden]="!inputFocused" (click)="triggerSearch($event)" class="btn btn-default"
                                name="searchBtn1">
                                <span class="searchsection advance-search-magnifier">
                                    <!-- <em class="topnav-icons fa fa-search"></em> -->
                                </span>
                            </button>
                        </div>
                        <div >
                            <p-dropdown class="drop-down w-100 from-section custom-border-radius custom-dropdown" id='search-dropdown' [styleClass]="'prime-dd-advance-search'"
                                [options]="searchInFolders" [dropdownIcon]="'none'"
                                [style]="{'margin-left': '10px','background': '#2B7DF8','border-color': 'rgb(43, 125, 248)'}"
                                formControlName="frmCtrlsearchInFolders">
                                <ng-template let-folder pTemplate="selectedItem">
                                    <span class="smart-search-ddselecteditem" style='border-radius:4px;padding-left: 8px !important'>
                                        {{folder.label}}
                                    </span>
                                </ng-template>
                                <ng-template let-folder pTemplate="item">
                                    <div class="ui-helper-clearfix" style="position: relative;height: 25px; align-content: center;">
                                        <div class="smart-search-dditems" >{{folder.label}}</div>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </div>
                        <!-- search box with auto populate -->
                        <div class="search-text-container" (click)="toggleSearchInput()"
                            [ngClass]=" inputFocused ? 'search-box-expanded' : 'search-box-collapsed'">
                            <p-autoComplete [suggestions]="savedSeachSingle"
                                (completeMethod)="filterSearchSingle($event)" field="name" [size]="30"
                                [placeholder]="txtPlaceholder" [minLength]="1"
                                [style]="{'width':'100%','border': 'none','font-size':'12px','font-family':'OpenSans','color':'#002d72'}"
                                [inputStyle]="{'width':'100%','border': 'none','font-size':'12px','font-family':'OpenSans','color':'#002d72','padding-left': '8px', 'height':'32px', 'padding-right':'75px'}"
                                (onClear)="clearItem(autocomplete)"
                                #autocomplete formControlName="searchText"
                                (keyup.enter)="callSearch($event,true,autocomplete)"
                                (onSelect)="onSelect($event,true,autocomplete)"
                                styleClass="override override-newmessage-autocomplete-topnav mob-mt5 searchInputWidth"
                                [maxlength]="smartSearchCharactersLimit" (keypress)="onAutoCompleteSearch($event)"
                                forceselection="true">
                            </p-autoComplete>
                        </div>
                        <div *ngIf="searchTextLength>0" class="input-group-btn searchBox" style='right:35px;border-left: none;  border-right: 1px solid #D8D9E5; padding-right: 8px;'>
                            <button class="btn btn-default adv-search-button" (click)="cancelSearch()">
                                <a style="display: inline-block;position: relative; top:-2px" [class.active]='clickStatusArray[0]'>
                                    <img src="assets/qwyn/icons/close-topbar.svg" alt="">
                                </a>
                            </button>
                        </div>
                        <div class="input-group-btn searchBox" style='border-left: none;'>
                            <button class="btn btn-default adv-search-button" (click)="toggleSearch()">
                                <a style="display: inline-block;position: relative; top:-2px" [class.active]='clickStatusArray[0]'>
                                    <img [src]="!clickStatusArray[1] ? 'assets/qwyn/icons/filter.svg':'assets/qwyn/icons/filter.svg'" alt="">
                                </a>
                            </button>
                        </div>
                    </div>
                    <div class="d-flex flex-row justify-content-end align-items-center header-options">
                        <div class="btn mobile-searchicon px-1" *ngIf="showMultiSelection && isMobile"
                            name="selectBtnMobile" (click)="mobileSelectClick($event)">
                            <div [ngClass]="(inboxService.mobileCheckboxSelected)?'isChecked':'isUnChecked'"></div>
                        </div>
                        <div class="mobile-sort-label px-1" *ngIf="showMultiSelection && isMobile"
                            (click)="mobileSortingClick($event,addToGrp)">
                            {{sortAttrLabel()}}
                        </div>
                        <div class="mobile-sort-icon px-1" *ngIf="showMultiSelection && isMobile"
                            (click)="mobileSortDirection($event,addToGrp)">
                            <!--<img src='assets/mobile/sort.svg' alt="">-->
                            <span [ngClass]="sortDirectionClass()"></span>
                        </div>
                        <div style="position:relative;" class="d-flex flex-row">
                            <p-overlayPanel [styleClass]="'mob-inbox-sorting sorting inbox-sorting'" [appendTo]="'body'"
                                #addToGrp [baseZIndex]="9999" [dismissable]="true">
                                <div class="d-flex flex-row align-items-center justify-content-between">
                                    <h6 class="radioMobSort">SORT BY</h6>
                                    <div class="close-leftNav" (click)="closeSortingModal($event,addToGrp)">
                                        <img src='assets/mobile/close_sort.svg' alt="Sort">
                                    </div>
                                </div>
                                <form [formGroup]="myForm">
                                    <div class="ui-g mobsorting-radio" style="width:250px;margin-top:6px">
                                        <div class="ui-g-12" *ngFor="let attr of sortAttrNames; let i = index">
                                            <p-radioButton class="radioBulkUpload" name="myRadio" value="{{i}}"
                                                label="{{attr}}" [(ngModel)]="sortAttrIndex" formControlName="myRadio"
                                                inputId="preopt{{i}}"></p-radioButton>
                                        </div>
                                    </div>
                                </form>
                            </p-overlayPanel>
                        </div>
                        <div *ngIf="showMultiSelection && isMobile"
                            class="d-flex flex-row align-items-center mobile-search-btn px-1"
                            (click)="mobileSearchClick()">
                            <img class="mobile-search-icon" src='assets/mobile/search.svg' alt="">
                        </div>
                    </div>
                    <div *ngIf="!firstClick" [hidden]="!advanceSearchVisible" class="advance-holder">
                        <app-adv-criteria (searchToggle)="toggleSearch()"></app-adv-criteria>
                    </div>
                </form>
            </div>
            <!-- <div *ngIf="showSearchError" class="invalid-feedback backfeed">

                <div>
                    <img src="assets/newMessage/error.svg" class="error" alt="Error">
                    Please provide minimum of 3 characters
                </div>
            </div> -->
        </div>
        <!-- Searchbox with dropdown section ends -->
        <ul class="d-flex align-items-center flex-row flex-nowrap mb-0" [ngClass]="checkIfActive()" id="topmenuhide">
            <div *ngIf='!searchboxClicked' style='margin-right: 30px !important;' [ngClass]="{'search-focused':inputFocused}">
                <div appOuterClick (outsideClick)="resetSearchBox($event)" class="navbar-left">
                    <form class="form-horizontal" [formGroup]="searchForm" (keydown.enter)="$event.preventDefault()">
                        <input type="text" pInputText [(ngModel)]="value" [ngModelOptions]="{standalone: true}" placeholder="Search" variant="filled"
                            class="custom-filled-input" (click)="onInputClick(true)" (mouseenter)="onInputClick(true)"/>
                        <img class="search-icon" [src]="'assets/qwyn/icons/search-icon.svg'" alt="">
                    </form>
                </div>
            </div>
            <div class="separator"></div>
            <li class="notification-icon" (click)="toggleHelpOverlay($event)" (keydown)="toggleHelpOverlay($event)">
                <a [class.active]='clickStatusArray[1]' (mouseover.prevent)="isHovered = true"
                (mouseleave.prevent)="isHovered = false" pTooltip="Help" tooltipPosition="bottom" tooltipStyleClass='leftTooltip p-tooltip-text customTooltip'>
                        <img [src]="'assets/qwyn/icons/vector.svg'" class="iconWithHover" alt="">
                </a>
            </li>
            <div class="separator"></div>
            <li class="notification-icon" [class.notify]="notificationCount>0" pTooltip="Notification" tooltipPosition="bottom" tooltipStyleClass='leftTooltip p-tooltip-text customTooltip'>
                <a style="display: inline-block;position: relative;" (click)="onOptionClick(0)" [class.active]='clickStatusArray[0]'>
                    <span  *ngIf="notificationCount > 0" class="notify-badge">{{notificationCount}}</span>
                    <img [src]="'assets/qwyn/icons/notification.svg'" class="iconWithHover"
                        alt="">
                </a>
            </li>

            <div class="separator"></div>
            <li class="profile-icon">
                <a (click)="onOptionClick(2)" [class.active]='clickStatusArray[2]'>
                    <img [src]="profilePicSrc" alt="" *ngIf="AuthKey">
                    <div class="display-individual" *ngIf="!AuthKey">{{userId.substring(0,2)}}</div>
                </a>
            </li>
        </ul>
        <p-overlayPanel #op [style]="{ width: '230px' }" styleClass="help-overlay">
            <ng-template pTemplate="content">
              <div class="help-container">
                <div class="d-flex align-items-center justify-content-between border-bottom pb-2 mb-1">
                  <div class="d-flex align-items-center">
                    <div class="help_icon_container">
                        <img src="assets/qwyn/icons/help_icon.svg">
                    </div>
                    <h5 class="m-0 helpMenuHeading">HELP</h5>
                  </div>
                </div>
                <div class="help-menu">
                    <!-- Help menu items -->
                    <div class="menu-item" (click)="showSupport(true)">
                        <a href="#" class="text-decoration-none text-dark">Get Support</a>
                    </div>
                    <div class="menu-item" (click)="showSupport(false)">
                        <a href="#" class="text-decoration-none text-dark">Submit Feedback</a>
                    </div>
                    <div class="menu-item">
                        <a [href]="trainingUrl" target="_blank" rel="noopener noreferrer" class="text-decoration-none text-dark">Training Material</a>
                    </div>
                    <div class="menu-item" (click)="showHelpReleaseNotes()">
                        <a href="#" class="text-decoration-none text-dark">Release Notes</a>
                    </div>
                </div>
              </div>
            </ng-template>
          </p-overlayPanel>
    </div>

</nav>

<p-dialog [header]="currentPreviewFile?.file?.name || 'File Preview'" [(visible)]="showPreviewModal" [modal]="true"
 [responsive]="true" [style]="viewStyleObject()" [minY]="70"
 [maximizable]="true" [baseZIndex]="10000" appendTo="body"
 (onHide)="closePreview()">
  <div [ngStyle]="contentStyleObject()">
    <div class="preview-body">
      <!-- Image previews -->
      <img *ngIf="isImageType(currentPreviewFile?.file.type)"
           [src]="getSafeUrl(currentPreviewFile.data)"
           class="image-preview"
           [alt]="currentPreviewFile?.file.name">

      <!-- PDF preview -->
      <iframe *ngIf="currentPreviewFile?.file.type === 'application/pdf'"
              [src]="getSafeUrl(currentPreviewFile.blobUrl)"
              class="pdf-preview"></iframe>

      <!-- Text-based previews -->
      <pre *ngIf="isTextType(currentPreviewFile?.file.type)"
           class="text-preview">{{currentPreviewFile?.data}}</pre>



      <!-- Office document preview (placeholder) -->
      <div *ngIf="isOfficeType(currentPreviewFile?.file.type)" class="office-preview">
        <div class="office-icon">
          <i [class]="getOfficeIconClass(currentPreviewFile?.file.type)"></i>
        </div>
        <p>{{currentPreviewFile?.file.name}}</p>
        <p>Use an external viewer to open this document</p>
      </div>

      <!-- Archive files preview -->
      <div *ngIf="isArchiveType(currentPreviewFile?.file.type)" class="archive-preview">
        <div class="archive-icon">
          <i class="fas fa-file-archive"></i>
        </div>
        <p>{{currentPreviewFile?.file.name}}</p>
        <p>File size: {{currentPreviewFile?.file?.size}}</p>
      </div>

      <!-- Default for unsupported file types -->
      <div *ngIf="!isSupportedPreviewType(currentPreviewFile?.file.type)" class="no-preview">
        <div class="file-icon">
          <i class="fas fa-file"></i>
        </div>
        <p>No preview available for {{currentPreviewFile?.file.name}}</p>
        <p>File type: {{currentPreviewFile?.file.type || 'Unknown'}}</p>
        <p>File size: {{currentPreviewFile?.file?.size}}</p>
      </div>
    </div>
  </div>
</p-dialog>

<!-- added for show release note start*/ -->
<p-dialog [(visible)]="display" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'" [styleClass]="'contextMenuModal currentRelease releaseNote'"
    [closable]="false" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true" [style]="{'width':'44%','height':'100%'}" (onHide)="onReleaseNotesDialogHide()">
    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between mx-2 mt-1">
            <h6 class="gfid-title" style="font-weight: bold;">Current Release Notes</h6>

            <button type="button" (click)="closeReleaseNotes()" class="d-flex flex-row close qma-text"
            style="margin: 0px 6px 0px 0px;">
            <img src="assets/qwyn/icons/close-grey.svg" alt="Close">
          </button>
        </div>
    </p-header>

    <div style="height: 100%;">
        <ngx-extended-pdf-viewer 
            [src]="releaseNoteUrl"
            [height]="'100%'"
            [showToolbar]="true"
            [showSidebarButton]="true"
            [sidebarVisible]="false"
            [activeSidebarView]="1"
            [zoom]="'auto'"
            [filenameForDownload]="relaseDoc"
            [showOpenFileButton]="false"
            [showWrappedScrollButton]="false"
            [showInfiniteScrollButton]="false"
            [showBookModeButton]="false"
            [showSinglePageModeButton]="false"
            [showVerticalScrollButton]="false"
            [showHorizontalScrollButton]="false"
            [showSpreadButton]="false"
            [showPropertiesButton]="false"
            [showFindButton]="true"
            [showDownloadButton]="true"
            [textLayer]="true">
        </ngx-extended-pdf-viewer>
    </div>

    <p-footer>
        <div class="d-flex flex-row flex-wrap bottom-button-holder justify-content-center">
            <button type="submit" class="btn release-notes-btn" (click)="updateReleaseNotesDocument()">OK</button>
        </div>
    </p-footer>

</p-dialog>

<!-- Support & feedback -->
<p-dialog [(visible)]="supportDisplay" #supportDialog [modal]="true" [responsive]="true" [maximizable]="false"
    [appendTo]="'body'" [styleClass]="'contextMenuModal profileModal'" [closable]="false"
    [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true" [style]="{'height':'615px','max-width':'1250px', 'width': '70%'}"
    [resizable]="false">
    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between feedback-header-padding" >
            <h6 class="gfid-title" style="font-size: 15px; font-weight: bold">{{supportFeedbackTitle}}</h6>
            <button (click)="hideSupport()" type="button" class="d-flex flex-row close qma-text"
                style="border:none !important;opacity:1">
                <img src="assets/Inbox/close_icon_u73.svg" style="opacity:1" alt="close">
            </button>
        </div>
    </p-header>
    <form [formGroup]="parentForm">
        <div class="gfid-body" >
            <div class="help-section ">
                <div class="d-flex flex-row justify-content-between  mt-4 mobile-form control-group">
                    <div class=" d-flex flex-row align-items-center" >
                        <label for="from" class="flex-grow feedbackLabel" >Subject:</label>
                        <input type="text" placeholder="Type here"
                        class="w-400 t-box inp-txt-mng group-details-input-mng"
                            formControlName="subject" />
                    </div>
                </div>
                <div class="d-flex flex-row justify-content-between  mt-4 mobile-form control-group">
                    <div class="d-flex flex-row align-items-center" >
                        <label for="from" class="flex-grow feedbackLabel" >Priority:</label>
                        <p-dropdown  [options]="priorities" formControlName="priority"
                        [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                        (onShow)="isDropdownOpen = true"
                        (onHide)="isDropdownOpen = false"
                        [ngClass]="{'signatureDropdown-open': isDropdownOpen}"
                        placeholder="Select">
                        </p-dropdown>
                    </div>
                </div>
                <div #overflowdiv [hidden]="true" class="w-100 d-flex flex-row align-items-start control-group ellipsis-overflow hidden ">
                    <div *ngIf="postDataForAttachmentFile" class="pull-left" id="listOffileAttached">
                        <div *ngFor="let attachment of postDataForAttachmentFile" class="attachment-single"
                            style="display:inline-flex; font-size: 12px; font-family: arial; margin-top:10px; margin-right: 14px; ">
                            <div class="elipsis-attachment">
                                <span id="{{attachment.id}}"><img src="assets/newMessage/notes.svg"
                                        class="attachment-img" alt="Notes">
                                    <a href="#" title="{{attachment.name}}" class="attachment-font"
                                        (click)="downloadAttachment(attachment.id,attachment.name)">{{attachment.name}}</a>
                                </span>
                            </div>
                            <span (click)='deleteAttachedFile(attachment.id)'>
                                <img src="assets/newMessage/attachdelete.svg" class="p-1 attchment-cross" alt="Delete">
                            </span>
                        </div>
                    </div>
                    <input type="hidden" name="attachments">
                </div>

                <div   *ngIf="postDataForAttachmentFile && postDataForAttachmentFile.length > 0"
                    class="new-attachement w-100 d-flex flex-row align-items-start control-group ellipsis-overflow attachement-grid-container mt-4">
                    <div *ngIf="postDataForAttachmentFile" class="pull-left" id="listOffileAttached"
                      [ngClass]="{'attachement-grid-verticle': inboxView === 'vertical','attachement-grid-horizontal': inboxView !== 'vertical'}">
                      <div *ngFor="let attachment of postDataForAttachmentFile"
                        style="display:inline-flex; font-size: 12px; font-family: arial;" class="attachement-item"
                        (mouseenter)="showAttachments(null, null, postDataForAttachmentFile)">
                        <!-- Start -->

                        <div class="new-attach-container box " *ngIf="!attachment.showMenuNew"
                          (mouseenter)="onMouseEnterNewAttTitle(attachment)" (mouseleave)="onMouseLeaveNewAttTitle(attachment)">
                          <div class="elipsis-attachment">
                            <span id="{{attachment.id}}">
                              <img [src]="getAttachementImageByExtension(attachment)" class="download-icon">
                              <!-- <a href="{{downloadUrl}}?docId={{attachment.id}}" title="{{attachment.name}}">{{attachment.name}}</a> -->
                              <a href="#" title="{{attachment.name}}" class="attachment-font"
                                (click)="downloadAttachment(attachment.id,attachment.name)">{{attachment.name}}</a>
                            </span>
                          </div>

                          <!-- End -->
                        </div>
                        <!-- Menu  -->
                        <div class="menu" *ngIf="attachment.showMenuNew" (mouseenter)="onMouseEnterNewAttMenu(attachment)"
                          (mouseleave)="onMouseLeaveNewAttMenu(attachment)">
                          <!-- (mouseleave)="onMouseLeaveNewAttTitle(attachment)" -->
                          <div class="eye-icon">
                            <img class="eye-img" (click)="onViewctionRedesigned(attachment)" title="View"
                              [src]="menuIconImageConfig.viewIconSrc"
                              (mouseover)="menuIconImageConfig.viewIconSrc = menuIconImageConfig.viewIconmouseOn"
                              (mouseout)="menuIconImageConfig.viewIconSrc = menuIconImageConfig.viewIconmouseOut">
                          </div>
                          <div class="menu-icons-border"></div>
                          <div class="image-container">
                            <!-- [src]="'assets/Inbox/download_icon_u70.svg'" -->
                            <img [src]="'assets/Inbox/download_icon_u70.svg'" class="download-icon" (click)="onDownloadAttachment(attachment)" title="Download"
                              [src]="menuIconImageConfig.downloadIconSrc"
                              (mouseover)="menuIconImageConfig.downloadIconSrc = menuIconImageConfig.downloadIconmouseOn"
                              (mouseout)="menuIconImageConfig.downloadIconSrc = menuIconImageConfig.downloadIconmouseOut">
                          </div>
                          <div class="menu-icons-border">

                          </div>
                          <div class="image-container">
                            <img class="copy-icon" [src]="menuIconImageConfig.copyIconSrc" name="copy"
                              (click)="onCopyActionRedesigned(attachment)" title="Copy"
                              (mouseover)="menuIconImageConfig.copyIconSrc = menuIconImageConfig.copyIconmouseOn"
                              (mouseout)="menuIconImageConfig.copyIconSrc = menuIconImageConfig.copyIconmouseOut">
                          </div>
                        </div>
                        <span (click)='deleteAttachedFile(attachment.id)'>
                          <img src="assets/newMessage/attachdelete.svg" class="p-1 attchment-cross">
                        </span>
                      </div>
                    </div>

                    <input type="hidden" name="attachments">
                  </div>



                <a class="d-flex flex-column justify-content-center ellipsis-btn"
                    *ngIf="checkOverFlow(overflowdiv) && !isElipsisShow"
                    (click)="showRemainingAttchment($event, attachmentOptions, postDataForAttachmentFile)">
                    <img src="assets/newMessage/ellipse.svg" class="p-1 ellipse-size" alt="More">
                </a>
                <div class="support-section">
                    <div *ngIf="editorFlag" >
                        <editor-app [elementId]="'feedbackText'" [toolbarOptions]="2" [height]="300" [fromNewMessage]="true"  class="my-editor"></editor-app>
                    </div>
                </div>
            </div>


            <p-footer class="footer-feedback marginFooter">
                <div class="feedbackButtonWrap">
                    <input name="files" id="files" type="file" multiple="true" style="display:none" #uploadFiles
                        (change)="fileEvent($event)" />
                    <button pButton class="attach-button" type="button" (click)="uploadFile()" >Attach</button>
                    <button pButton class="cancel-button" type="reset"  (click)='resetHelp()'>Reset</button>
                    <button pButton class="submit-button" type="button" (click)="sendFeedback()">Send</button>
                </div>
            </p-footer>
        </div>
    </form>
</p-dialog>
<!-- Support & feedback success modal -->
<p-dialog [(visible)]="displaySuccess" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
    [styleClass]="'contextMenuModal successModal ModelClose'" [closable]="true" [dismissableMask]="true"
    [baseZIndex]="10000" [closeOnEscape]="true" [style]="{width: '30%'}">
    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between">
            <h6 class="success-title">Success Confirmation</h6>
        </div>
    </p-header>
    <div class="success-msg">{{supportType}} sent successfully!</div>
</p-dialog>
<!-- added for show release note end */ -->
<div>
</div>
